import styles from './MultimediaButtonContent.module.css'
import { Loader } from 'is24-corecss'
import React from 'react'

type MultimediaButtonLoadingContentProps = {
  title: string
  subtitle: string
}

const MultimediaLoadingButtonContent: React.FC<MultimediaButtonLoadingContentProps> = ({ title, subtitle }) => {
  return (
    <div>
      <div className={`${styles.loaderContainer} padding-bottom-s`}>
        <Loader variant='secondary' colorSet='darkGray' />
      </div>
      <div>
        <span className={`font-body-medium-bold ${styles.title}`}>{title}</span>
      </div>
      <div>
        <span className={`font-body-small-regular ${styles.subtitle}`}>{subtitle}</span>
      </div>
    </div>
  )
}

export default MultimediaLoadingButtonContent
